"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const debug_1 = __importDefault(require("debug"));
const defaults_1 = __importDefault(require("./defaults"));
const utils_1 = require("./utils");
const log = (0, debug_1.default)('exchange-parser:block-renderer');
class BlockRenderer {
    constructor(options) {
        this.code = (text, lang, escaped, escapeNotebooks, disableNotebooks) => {
            log('Rendering code', text, lang, escaped);
            text = (0, utils_1.getText)(text);
            if (lang === 'notebook' && !disableNotebooks) {
                return `<script type="text/x-api-notebook">${escapeNotebooks ? this.options.escape(text) : text}</script>`;
            }
            if (!lang) {
                return `<pre><code>${escaped ? text : this.options.escape(text)}</code></pre>`;
            }
            if (this.options.highlight) {
                const out = this.options.highlight(text, lang);
                if (out && out !== text) {
                    escaped = true;
                    text = out;
                }
            }
            return `<pre><code class="${this.options.langPrefix}${this.options.escape(lang)}">${escaped ? text : this.options.escape(text)}</code></pre>`;
        };
        this.blockquote = (quote) => {
            log('Rendering quote', quote);
            return `<blockquote>${(0, utils_1.getText)(quote)}</blockquote>`;
        };
        this.html = (text) => {
            log('Rendering HTML', text);
            let parsedText = (0, utils_1.getText)(text);
            const trimmed = parsedText.toLowerCase().trim();
            const isImg = trimmed.startsWith(`<img `) ||
                trimmed === `<img>` ||
                trimmed === `<img/>`;
            if (this.options.imgSrc && isImg) {
                const [, src] = /\s+src\s*=\s*"([\s\S]+?)"/i.exec(parsedText) || [];
                parsedText = parsedText.replace(src, this.options.imgSrc);
            }
            return parsedText;
        };
        this.heading = (text, level, raw, minLevel) => {
            log('Rendering heading', text, level, raw);
            const levelWithMin = level + minLevel - 1;
            const actualLevel = levelWithMin <= 6 ? levelWithMin : 6;
            return `<h${actualLevel} id="${raw
                .toLowerCase()
                .replace(/[^\w]+/g, '-')
                .replace(/^-|-$/g, '')}">${(0, utils_1.getText)(text)}</h${actualLevel}>`;
        };
        this.hr = () => {
            log('Rendering hr');
            return '<hr>';
        };
        this.list = (body, ordered) => {
            log('Rendering list', body, ordered);
            const type = ordered ? 'ol' : 'ul';
            return `<${type}>${(0, utils_1.getText)(body)}</${type}>`;
        };
        this.listitem = (text) => {
            log('Rendering list item', text);
            text = (0, utils_1.getText)(text)
                .replace(/^\[ \] /, '<input type="checkbox" disabled>')
                .replace(/^\[x\] /, '<input type="checkbox" disabled checked>');
            return `<li>${text}</li>`;
        };
        this.paragraph = (text) => {
            log('Rendering paragraph', text);
            return `<p>${(0, utils_1.getText)(text)}</p>`;
        };
        this.table = (header, body) => {
            log('Rendering table', header, body);
            body = (0, utils_1.getText)(body);
            return `<div style="overflow-x: auto" class="table"><table><thead>${header}</thead>${body ? `<tbody>${body}</tbody>` : ''}</table></div>`;
        };
        this.tablerow = (content) => {
            log('Rendering table row', content);
            content = (0, utils_1.getText)(content);
            return `<tr>${content}</tr>`;
        };
        this.tablecell = (content, flags) => {
            log('Rendering table cell', content, flags);
            content = (0, utils_1.getText)(content);
            const type = flags.header ? 'th' : 'td';
            const tag = flags.align
                ? `<${type} style="text-align:${flags.align}">`
                : `<${type}>`;
            return `${tag + content}</${type}>`;
        };
        this.options = Object.assign(Object.assign({}, defaults_1.default), options);
    }
}
exports.default = BlockRenderer;
